import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { getInterestLabel } from "../../../../../lib/generic";
import { ListingCoachAndCollabImgs } from "../ListingCoachAndCollabImgs";
import { ListingDetailsHeaderWrapper } from "./ListingDetailsHeaderWrapper";
import { ListingDetailsHeaderContentWrapper } from "./ListingDetailsHeaderContentWrapper";
import {
  BodyMedium,
  TitleLargeProminent,
} from "../../../../global/ui/typography";

export const ListingDetailsHeader = () => {
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType,
  );

  return (
    <ListingDetailsHeaderWrapper>
      <ListingCoachAndCollabImgs />
      <ListingDetailsHeaderContentWrapper>
        <TitleLargeProminent>
          {listingType} by {trainingPlanRedux.user.name}
          {trainingPlanRedux.collaborators.length > 0
            ? `, with ${trainingPlanRedux.collaborators[0].title}`
            : ""}
          {trainingPlanRedux.collaborators.length === 2
            ? ` & ${trainingPlanRedux.collaborators[1].title}`
            : ""}
        </TitleLargeProminent>
        <BodyMedium>
          {getInterestLabel(trainingPlanRedux.user.interest)}{" "}
        </BodyMedium>
      </ListingDetailsHeaderContentWrapper>
    </ListingDetailsHeaderWrapper>
  );
};
